export default "__VITE_ASSET__961807d8__"